import { OAuthCallback } from '@client/components/OAuthCallback';
import { postMicrosoftAuthCodeByAdvisorIdRequest } from '@client/model/sessionModel';
import { useMemo } from 'react';
export function MicrosoftOAuthCallback() {
  const providerConfig = useMemo(
    () => ({
      provider: 'microsoft' as OAuthProvider,
      title: 'Microsoft Account Connected Successfully!',
      dispatchAction: postMicrosoftAuthCodeByAdvisorIdRequest,
    }),
    [],
  );
  return <OAuthCallback providerConfig={providerConfig} />;
}
